import React from "react";
import ActivityTemplateButton from "../common/ActivityTemplateButton";
import ActivityFooter from "../common/ActivityFooter";

const BurndownChartFinal = ({ template, onBack, color, onContinue }) => {
  return (
    <div>
      <div className="content-area flex-grow flex flex-col justify-center px-15 sm:px-50 lg:px-15 py-20 text-center">
        <div className="tracking-wider md:w-8/12 lg:6/12 mx-auto">
          <h1 className="mt-0 mb-16 font-bold text-lg font-secondary text-gray-800 leading-xxxl">
            <span className="block mb-5">WAHOOOO</span>You completed your
            <br />
            Burndown Chart!
          </h1>
          <span className="icon-star-full text-yellow-100 leading-none text-96 inline-block align-top mb-45"></span>

          {template.hasTemplate && (
            <ActivityTemplateButton template={template} color={color} />
          )}
        </div>
      </div>

      <ActivityFooter
        color={color}
        onBack={onBack}
        onContinue={onContinue}
        isFinal={true}
      />
    </div>
  );
};

export default BurndownChartFinal;
